/**
 * Base controller: owns a module's business logic and is the single point other
 * modules go through to interact with it. Holds a manager + a mounted view.
 */
export default class BaseController {
  constructor({ manager } = {}) {
    this.manager = manager;
    this.view = null; // the currently mounted top-level component
  }

  /** Mount a component into a container, unmounting any previous view. */
  async mountView(ComponentClass, props, container) {
    if (this.view) this.view.unmount();
    this.view = new ComponentClass(props);
    await this.view.mount(container);
    return this.view;
  }

  unmountView() {
    this.view?.unmount();
    this.view = null;
  }
}
